module.exports = "/_next/static/images/polis-e8d4b79cfda259a541f1dbec3bef53e0.png";